import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import plLocale from "date-fns/locale/pl";
import React from "react";
import ReactDOM from "react-dom";
import retargetEvents from "react-shadow-dom-retarget-events";
import * as serviceWorker from "./serviceWorker";
import { Provider as MobxProvider } from "mobx-react";
import { stores as mobxStores } from "./stores/stores";
import "@webcomponents/custom-elements/custom-elements.min";
import App from "./components/app/app";
import "./index.scss";
import { Environments } from "./helpers/envinonment";
import { create } from "jss";
import { StylesProvider, jssPreset } from "@material-ui/styles";

class TuzEstateWidget extends HTMLElement {
  private readonly partnerName: string;
  private readonly environment: string;

  constructor() {
    super();
    this.environment = (this.getAttribute("environment") || "");
    this.partnerName = (this.getAttribute("partnerName") || "");
  }

  public connectedCallback() {
    const mountPoint = document.createElement("div");
    const mountPoint2 = document.createElement("div");
    const shadowRoot = this.attachShadow({ mode: "open" });

    shadowRoot.appendChild(mountPoint);
    shadowRoot.appendChild(mountPoint2);

    const jss = create({
      ...jssPreset(),
      insertionPoint: mountPoint2
    });

    // for Material UI component like DropDown, PopUp, DatePicker
    jss.use({
      onProcessSheet: (sheet) => {
        // @ts-ignore
        const element = sheet.renderer.element as HTMLElement;
        const dataMeta = element.getAttribute("data-meta") as string;
        let style = document.getElementById(dataMeta);
        if (!style) {
          // Because innerHTML is async
          setTimeout(() => {
            style = document.createElement("style");
            style.id = dataMeta;
            style.innerHTML = element.innerHTML;
            document.head.appendChild(style);
          }, 500);
        }
      }
    });

    ReactDOM.render(
      <div className="ecom-app-wrapper">
        <MobxProvider {...mobxStores}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
            <StylesProvider jss={jss}>
              <App partnerName={this.partnerName} environment={this.environment} />
            </StylesProvider>
          </MuiPickersUtilsProvider>
        </MobxProvider>
      </div>,
      mountPoint,
      () => this.appendStyles(mountPoint2)
    );

    retargetEvents(shadowRoot);
  }

  public disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }

  private appendStyles(mountPoint2: HTMLDivElement) {
    let styles = null;

    if (this.environment === Environments.localhost) {
      styles = document.getElementsByTagName("style");
    } else {
      styles = [];
      styles.push(...document.querySelectorAll("[id*='tuz_estate_widget_style']"));
    }

    for (let i = 0, length = styles.length; i < length; i++) {
      mountPoint2.innerHTML += styles[i].outerHTML;
    }
  }
}

customElements.define("tuz-estate-widget", TuzEstateWidget);

serviceWorker.unregister();
